import { render } from "./DefaultPostMoreSectionNewsV2Cmp.vue?vue&type=template&id=a24fecda"
import script from "./DefaultPostMoreSectionNewsV2Cmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostMoreSectionNewsV2Cmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__